import { useBoolean } from "hooks";

import { ReturnDetails } from "../../../../returns.types";

export const useReturnModalModals = (_returnDetails?: ReturnDetails) => {
  const approveModal = useBoolean(false);

  const rejectModal = useBoolean(false);

  return {
    approveModal,
    rejectModal
  };
};
